.guarantee {
  position: relative;
  width: 100%;
  border-radius: 32px;
  border: 4px solid var(--ed-border, #00A66B);
  padding: 20px 20px 36px;

  h3 {
    color: #1A1A1A;
    text-align: center;
    font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto', sans-serif);
    font-size: 24px;
    font-weight: 700;
    line-height: 29px;
    margin-bottom: 10px;
  }

  p {
    color: #7B766F;
    text-align: center;
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.045px;

    a {
      text-decoration: underline;
    }
  }

  p + p {
    margin-top: 20px;
  }

  img {
    position: absolute;
    bottom: -56px;
    left: 50%;
    transform: translateX(-50%);
    width: 84.603px;
    height: 82px;
    min-width: 84.603px;
    min-height: 82px;
  }
}

.guarantee.discount {
  border: 4px solid #FF8600;
  
  h3 {
    color: #FFFBF1;  
  }

  p {
    color: #FFFBF1;
    opacity: 0.8
  }
}